import { createFileRoute } from '@tanstack/react-router'
import TeamsManagement from '../../../../../containers/TeamsManagement'
import { teamSearchSchema } from './search-schemas'

export const Route = createFileRoute('/_authenticated/project/$projectId/team/')({
  validateSearch: teamSearchSchema,
  component: TeamsManagement
})
